import { render, staticRenderFns } from "./datasourceSearch.vue?vue&type=template&id=21c787c2&"
import script from "./datasourceSearch.vue?vue&type=script&lang=js&"
export * from "./datasourceSearch.vue?vue&type=script&lang=js&"
import style0 from "./datasourceSearch.vue?vue&type=style&index=0&id=21c787c2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports